import React from 'react';
import PropTypes from 'prop-types';
import utilFunction from '../../../containers/function';
import SimpleIndicator from '../indicators/simpleIndicator';
import Label from '../label';
import strings from '../../locales/';

const BehaviorIndicator = (props) => (
	<section className={"behavior-indicator"}>
		<SimpleIndicator 
			value={props.data.items.reduce(
				function(valorAnterior, valorActual, indice, vector){
					if(valorActual.type=="grade") {
						valorAnterior = valorActual.value;
					}
					return valorAnterior;
				},null)
			} 
			valueFormat={{type:"NUMBER", format:".0f"}}
            graphColorRange={props.graphColorRange}
		/>
		<div className="simple-indicator-kpi-wrapper">
			<SimpleIndicator 
				value={props.data.items.reduce(
					function(valorAnterior, valorActual, indice, vector){
						if(valorActual.type=="kpi") {
							valorAnterior = valorActual.value;
						}
						return valorAnterior;
					},null)
				} 
				valueFormat={{
					type:"NUMBER", 
					format:props.config.kpiUnitFormat, 
					factor:(props.config.kpiUnitMultiplier)?props.config.kpiUnitMultiplier:1
				}}
			/>
			<Label label={props.config.kpiUnitName}/>
		</div>
		<Label label={props.config.name}/>
	</section>
);

export default BehaviorIndicator;




// WEBPACK FOOTER //
// ./source/client/components/common/behavior/behaviorIndicator.jsx